import imageField from 'molecules/Image/config';
import sectionFields from 'molecules/Section/config';

import { wistiaFormReferenceFields } from 'components/WistiaForm/config';

import type { Component, Input } from '@builder.io/sdk';
import type { WistiaFormReference } from 'components/WistiaForm/config';

const connectRegistrationFields = [
  {
    ...imageField('wordmark'),
    helperText: 'Desktop "CONNECT ‘26" wordmark image (uploaded, includes the Prismatic logo and the gradient).',
  },
  {
    ...imageField('wordmarkMobile'),
    helperText: 'Optional mobile wordmark image (≤640px), e.g. the stacked version. Falls back to the desktop one.',
  },
  {
    name: 'body',
    type: 'longText',
    helperText: 'Supporting copy shown below the wordmark.',
  },
  {
    ...imageField('orbImage'),
    helperText: 'Optional decorative image (e.g. the 3D orb) shown at the bottom of the left column.',
  },
  {
    name: 'redirectUrl',
    type: 'url',
    helperText:
      'Optional. Where to send the visitor after they submit the form (e.g. the thank-you page: https://prismatic.io/thank-you/prismatic-connect-2026/). Leave empty to keep Wistia’s default behaviour.',
  },
  ...wistiaFormReferenceFields(),
  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const connectRegistrationConfig = {
  name: 'ConnectRegistration',
  inputs: connectRegistrationFields,
} satisfies Component;

export type ConnectRegistrationConfigProps = Omit<GenerateBuilder<typeof connectRegistrationFields>, 'form'> & {
  form?: WistiaFormReference;
};

export default connectRegistrationConfig;
